// Configurazione per tre ambienti: development, labs, production

// 🔧 IMPOSTA L'AMBIENTE QUI - Deve essere uguale a quello in local.config.js
const CURRENT_ENVIRONMENT = 'production'; // Valori possibili: 'development', 'labs', 'production'

// Debug: log dell'ambiente corrente
console.log('🌍 API Environment set to:', CURRENT_ENVIRONMENT);

let API_BASE_URL;

if (process.env.REACT_APP_API_BASE_URL) {
  // Se è specificato un URL personalizzato, usalo
  API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
} else {
  // Altrimenti usa la configurazione basata sull'ambiente
  switch (CURRENT_ENVIRONMENT) {
    case 'development':
      API_BASE_URL = "https://ft7hhfpae3.execute-api.eu-west-1.amazonaws.com/dev";
      break;
    case 'labs':
      API_BASE_URL = "https://ft7hhfpae3.execute-api.eu-west-1.amazonaws.com/dev";
      break;
    case 'production':
      API_BASE_URL = "https://zz8eo51q74.execute-api.eu-west-1.amazonaws.com/prd";
      break;
    default:
      // Default a labs se l'ambiente non è riconosciuto
      API_BASE_URL = "https://ft7hhfpae3.execute-api.eu-west-1.amazonaws.com/dev";
      break;
  }
}

export const API_ENDPOINTS = {
    PROJECTS: `${API_BASE_URL}/projects`,
    USERS: `${API_BASE_URL}/users`,
    ACTIVITIES: `${API_BASE_URL}/activities`,
    WORKLOGS: `${API_BASE_URL}/worklogs`,
    CUSTOMERS: `${API_BASE_URL}/customers`,
    TEAMS: `${API_BASE_URL}/teams`,
    STATUS: `${API_BASE_URL}/statuses`,
    EFFORT_TYPES: `${API_BASE_URL}/effort_types`,
    USER_EFFORT_SUMMARY: `${API_BASE_URL}/user_effort_summary`,
    MONTHLY_WORKLOG_SUMMARY_USER_PROJECT: `${API_BASE_URL}/monthly_worklog_summary_user_project`,
    PROJECT_ROLES: `${API_BASE_URL}/project-roles`,
    PEOPLE_ROLES: `${API_BASE_URL}/people-roles`,
    PROJECT_USERS: `${API_BASE_URL}/project-users`,
    ROLES: `${API_BASE_URL}/roles`,
    TEAM_MEMBERS: `${API_BASE_URL}/teams`, // Per /teams/{id}/members
    PROJECT_ACTIVITIES: `${API_BASE_URL}/project-activities`,
    ABSENCES: `${API_BASE_URL}/absences`,
    REF_LOOKUP: `${API_BASE_URL}/ref-lookup`,
    FIELD_DEFINITIONS: `${API_BASE_URL}/field-definitions`,
    DATA_SOURCE: `${API_BASE_URL}/data-source`,
    SHEET_MAPPING: `${API_BASE_URL}/sheet-mapping`,
    FIELD_CONFIG: `${API_BASE_URL}/field-config`,
    MAPPING_VALUES: `${API_BASE_URL}/mapping-values`,
    CONTRACTS: `${API_BASE_URL}/contracts`,
    FORECAST_CELLS: `${API_BASE_URL}/forecast-cells`,
    FORECAST_CONFIG: `${API_BASE_URL}/forecast-config`,
};

export { API_BASE_URL };
export default API_ENDPOINTS; 